import {makeAutoObservable} from 'mobx';
import {RootStore} from './RootStore';
import AdminApiManager from 'services/API/AdminApi/AdminApiManager';

export interface SchoolData {
  name: string;
  address: string;
  directorName: string;
  directorEmail: string;
}

export interface IAdminGeneralStore {
  schoolData: SchoolData;

  fetchSchoolData: () => void;
}

export class AdminGeneralStore implements IAdminGeneralStore {
  private adminApiManager = new AdminApiManager();
  private rootStore: RootStore;

  schoolData: SchoolData = {
    name: '',
    address: '',
    directorName: '',
    directorEmail: '',
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }

  setSchoolName(name: string): void {
    this.schoolData.name = name;
  }

  setSchoolAddress(value: string): void {
    this.schoolData.address = value;
  }

  setDirectorName(name: string): void {
    this.schoolData.directorName = name;
  }

  setDirectorEmail(email: string): void {
    this.schoolData.directorEmail = email;
  }

  setSchoolData = (data: SchoolData) => {
    this.schoolData = data;
  };

  getSchoolData = () => {
    return this.schoolData;
  };

  fetchSchoolData = async () => {
    this.rootStore.loaderStore.startLoading();
    try {
      const response = await this.adminApiManager.getTenant();
      this.setSchoolData(response);
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }
  };

  updateSchoolData = async () => {
    this.rootStore.loaderStore.startLoading();

    try {
      await this.adminApiManager.updateTenant(this.schoolData);
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }
  };
}
